import List from "./pages/List";
import Wizard from "./pages/Wizard";

const routes = [
  {
    path: "*",
    element: List,
    permissions: ["SHIPMENT_MODULE"],
  },
  {
    path: ":id/*",
    element: Wizard,
    permissions: ["SHIPMENT_MODULE"],
  },
];

export default routes;
